
const NUM_THINKING_TEXTS = 129; // count by the number of "component.finAgentThinkingMessage.text_N" in locale files
export default {
    name: 'FinAgentThinkingMessage',

    data() {
        return {
            currentTextIndex: 0,
            thinkingInterval: null,
        };
    },

    mounted() {  
        this.startThinkingAnimation();  
    },

    beforeDestroy() {
        this.stopThinkingAnimation();
    },

    methods: {
        startThinkingAnimation() {
            this.currentTextIndex = Math.floor(Math.random() * (NUM_THINKING_TEXTS - 1)); // get random start index
            this.thinkingInterval = setInterval(() => {
                this.currentTextIndex = (this.currentTextIndex + 1) % NUM_THINKING_TEXTS;
            }, 2500);
        },

        stopThinkingAnimation() {
            if (this.thinkingInterval) {
                clearInterval(this.thinkingInterval);
            }
        }
    }
}
